import React from 'reactn';

import Page from 'components/Page';

const Loading: React.FC = () => <Page>{/* Loading*/}</Page>;

export default Loading;
